import React from 'react';
import StoryRender, {StoryRenderProps} from './StoryRender';



export const Story=({...props}:StoryRenderProps):JSX.Element=>{
	return <StoryRender {...props}/>;
};
